


















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class StatusLokalis extends Vue {
  @Prop() setLokalis: string;
  catatan = "";
  label = "";
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];

  @Watch("catatan")
  changeLokalis(v) {
    if (v == "") {
      this.label = "";
    } else {
      this.label = "Catatan Lokalis";
    }
    this.$emit("lokalis", v);
  }
  @Watch("setLokalis")
  changeSetLokalis(v) {
    this.catatan = v;
  }
}
